import { ApplicationConfig, inject, provideZoneChangeDetection, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { HttpInterceptorFn, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { EMPTY } from 'rxjs';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { AppService } from './shared/services/app.service';
import { DemoService } from './shared/services/demo.service';
import { RealService } from './shared/services/real.service';

const browserOnlyInterceptor: HttpInterceptorFn = (req, next) =>
  isPlatformBrowser(inject(PLATFORM_ID)) ? next(req) : EMPTY;

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([browserOnlyInterceptor])),
    {
      provide: AppService,
      useClass: environment.demoMode ? DemoService : RealService,
    },
  ],
};
